function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bookmark{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-1.75 -6.75)"
}, React.createElement("path", {
  className: "bookmark",
  d: "M2.5,15.5l6-3,6,3V2.5a2,2,0,0,0-2-2h-8a2,2,0,0,0-2,2Z",
  transform: "translate(0 7)"
}));

const SvgBookmark = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13.5,
    height: 16.5,
    viewBox: "0 0 13.5 16.5",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBookmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookmark.0a7cf25b.svg";
export { ForwardRef as ReactComponent };